<div fxLayout="row" class="template-preview__root">
  @if (!isMobile) {
    <div fxFlex="5" fxLayoutAlign="center start">
      <button mat-button
        class="template-preview__back-btn-arrow"
        data-testid="back-button"
        (click)="backBtnClicked.emit()">
        <i class="material-icons">arrow_back</i>
      </button>
    </div>
  }
  <div fxFlex="95">
    <mat-tab-group class="template-preview__tab-group"
      [selectedIndex]="selectedTabIndex"
      (selectedTabChange)="onSelectedTabChange($event.index)"
      animationDuration="0ms"
      mat-align-tabs="center">
      @if (shouldShow(email)) {
        <mat-tab data-testid="email-tab" label="Email">
          @if (templateHtml) {
            <div>
              <preview-selection containerId="headerContainer"
                [isDisabled]="!isChangeThemeEnabled"
                [elementId]="'cfa-header'"
                [text]="'Update Your Template'"
                [html]="templateHtml"
                (elementClicked)="changeThemeClicked.emit()">
              </preview-selection>
              <preview-selection containerId="changeImageContainer"
                [isDisabled]="!additionalImagesAvailable() || !isChangeImageEnabled"
                [elementId]="'cfa-image'"
                [text]="'Update Image'"
                [html]="templateHtml"
                (elementClicked)="changeImageClicked.emit()">
              </preview-selection>
              <preview-selection containerId="copyContainer"
                [isDisabled]="!isChangeCopyEnabled"
                [elementId]="'cfa-copy'"
                [text]="'Update Email Message'"
                [html]="templateHtml"
                (elementClicked)="changeCopyClicked.emit()">
              </preview-selection>
              <div class="template-preview__scale-shell" #previewShell>
                <div class="template-preview__template template-preview__scale-stage" #previewStage [innerHTML]="templateHtml"></div>
              </div>
            </div>
          }
          @if (!templateHtml) {
            <div>
              <img alt='' class="template-preview__image" src='../../../assets/img/preview_placeholder.png'/>
            </div>
          }
        </mat-tab>
      }
      @if (shouldShow(event)) {
        <mat-tab label="RSVP Reminder">
          @if (rsvpHtml) {
            <div class="template-preview__scale-shell" #previewShell>
              <div class="template-preview__template template-preview__scale-stage" #previewStage [innerHTML]="rsvpHtml"></div>
            </div>
          }
          @if (!rsvpHtml) {
            <div>
              <img alt='' class="template-preview__image" src='../../../assets/img/preview_placeholder.png'/>
            </div>
          }
        </mat-tab>
      }
      @if (shouldShow(event)) {
        <mat-tab label="No RSVP Reminder">
          @if (noRsvpHtml) {
            <div class="template-preview__scale-shell" #previewShell>
              <div class="template-preview__template template-preview__scale-stage" #previewStage [innerHTML]="noRsvpHtml"></div>
            </div>
          }
          @if (!noRsvpHtml) {
            <div>
              <img alt='' class="template-preview__image" src='../../../assets/img/preview_placeholder.png'/>
            </div>
          }
        </mat-tab>
      }
      @if (shouldShow(reward) && !appPreviewOverride) {
        <mat-tab label="Chick-fil-A App">
          <img alt='' class="template-preview__reward-message-image"
            src='../../../assets/img/reward-message-preview.png'/>
        </mat-tab>
      }
      @if (shouldShow(reward) && appPreviewOverride) {
        <mat-tab label="Chick-fil-A App">
          <shared-reward-app-preview
            [primaryHeading]="rewardLocationName ? ('To you, from ' + rewardLocationName) : ''"
            [rewardProductName]="rewardProductName"
            [rewardGiftMessage]="rewardGiftMessage"
            [rewardProductImageUrl]="rewardProductImageUrl"
            [rewardExpiryDate]="rewardExpiryDate"
            [rewardOperatorImageUrl]="getRewardOperatorImageUrl()"
            [includeOperatorPhoto]="includeOperatorPhoto"
            [rewardOperatorName]="rewardOperatorName"
            [hideGiftedSection]="false">
          </shared-reward-app-preview>
        </mat-tab>
      }
      @if (shouldShow(bonusPoint) && !isMobile) {
        <mat-tab label="Chick-fil-A App Promotion">
          <img alt='' class="template-preview__bpp-image"
            src='https://www.cfacdn.com/img/Spotlight/Other/BPP-desktop.svg'/>
        </mat-tab>
      }
      @if (shouldShow(cce) && !isMobile) {
        <mat-tab label="Chick-fil-A App">
          <img alt='' class="template-preview__community-image"
            src='https://www.cfacdn.com/img/Spotlight/CFA_Combined_mobile_previews.svg'/>
        </mat-tab>
      }
      @if (shouldShow(freeInCart) && !isMobile) {
        <mat-tab label="Chick-fil-A App">
          <img alt='' class="template-preview__community-image"
            src='https://www.cfacdn.com/img/Spotlight/Other/FIC_Mobile_combined.png'/>
        </mat-tab>
      }
      @if (shouldShow(thirdPartPromo)) {
        <mat-tab label="Third Party Platform View">
          <div fxLayout = "column" fxLayoutAlign = "center">
            <div  fxLayout = "row" fxLayoutAlign = "center">
              <img alt='' class="template-preview__third-party-promotion-image"
                src='https://www.cfacdn.com/img/Spotlight/Icons/3P_Promotions_App.png'/>
            </div>
            <div  fxLayout = "row" fxLayoutAlign = "center" class = "template-preview__text">
              <span class = "template-preview__bold-font">Note:</span> This image is for demonstrational purpose only, and does not display the exact experience of customers
            </div>
          </div>
        </mat-tab>
      }
      @if (shouldShow(bonusPoint) && isMobile) {
        <mat-tab label="Preview 1">
          <img alt='' class="template-preview__bpp-image"
            src='https://www.cfacdn.com/img/Spotlight/Other/BPP-mobile-app-confirmation.svg'/>
        </mat-tab>
        <mat-tab label="Preview 2">
          <img alt='' class="template-preview__bpp-image"
            src='https://www.cfacdn.com/img/Spotlight/Other/BPP-mobile-app-destination.svg'/>
        </mat-tab>
      }
      @if (shouldShow(cce) && isMobile) {
        <mat-tab label="Preview 1">
          <img alt='' class="template-preview__bpp-image"
            src='https://www.cfacdn.com/img/Spotlight/CCE_1.2.0_modal.svg'/>
        </mat-tab>
        <mat-tab label="Preview 2">
          <img alt='' class="template-preview__bpp-image"
            src='https://www.cfacdn.com/img/Spotlight/CCE_3rd_Step.svg'/>
        </mat-tab>
      }
      @if (shouldShow(freeInCart) && isMobile) {
        <mat-tab label="Preview 1">
          <img alt='' class="template-preview__bpp-image"
            src='https://www.cfacdn.com/img/Spotlight/Other/FIC_Select_Delivery.png'/>
        </mat-tab>
        <mat-tab label="Preview 2">
          <img alt='' class="template-preview__bpp-image"
            src='https://www.cfacdn.com/img/Spotlight/Other/FIC_MB.png'/>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</div>
